'use client'
import { useComponentTranslation } from '@core/i18n'
import { Button, Flex, Icon } from '@core/ui-elements'
import Image from '@core/ui-elements/image/Image'
import Text from '@core/ui-elements/text/Text'
import { useRouter } from 'next/navigation'
import { TFunction } from 'next-i18next'
import { FC } from 'react'
import { MdCached } from 'react-icons/md'

export const UnauthorizedHub: FC = () => {
  const t = useComponentTranslation('UnauthorizedHub') as TFunction

  const router = useRouter()

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      margin={0}
      padding="20vh 0"
      width={'100%'}
    >
      <Flex
        flexDirection={'column'}
        maxWidth={'28.125rem'}
        minWidth={'21.875rem'}
        padding={'0.875rem 1.25rem'}
        position="relative"
        textAlign="center"
        width={'90%'}
      >
        <Image
          alt="HUBR"
          src="/images/top-right-corner.svg"
          style={{
            height: '1.375rem',
            position: 'absolute',
            top: 0,
            right: 0,
            margin: 'auto',
          }}
        />
        <Image
          alt="HUBR"
          src="/images/top-left-corner.svg"
          style={{
            height: '1.375rem',
            position: 'absolute',
            top: 0,
            left: '0.875rem',
            margin: 'auto',
          }}
        />
        <Image
          alt="HUBR"
          src="/images/bottom-left-corner.svg"
          style={{
            height: '1.375rem',
            position: 'absolute',
            bottom: 0,
            left: 0,
            margin: 'auto',
          }}
        />
        <Image
          alt="HUBR"
          src="/images/bottom-right-corner.svg"
          style={{
            height: '1.375rem',
            position: 'absolute',
            bottom: 0,
            right: '0.875rem',
            margin: 'auto',
          }}
        />
        <Text fontWeight="bold" marginBottom="1rem">
          {t('You dont have access to this Hub')}
        </Text>

        <Text fontSize="0.875rem" marginBottom="1rem">
          {t('Check the ID you entered')}
        </Text>

        <Button
          leftIcon={<Icon as={MdCached} color={'blue.500'} />}
          variant="ghost"
          onClick={() => router.refresh()}
        >
          {t('Update page')}
        </Button>
      </Flex>
    </Flex>
  )
}
